import { connect } from "react-redux";

import { FullFormState } from "../../../../Engine/Core/Store/FullFormState";
import { HintsViewMode } from "../../../Internals/ViewModeSelector/ViewModes";

import { FillHint } from "./FillHint";

const mapStateToProps = (state: FullFormState) => ({
    visible: state.viewModes.hints === HintsViewMode.Show,
});

export const FillHintContainer = connect(mapStateToProps)(FillHint);
